import { DateSelectionMode } from '@kurtosys/ksys-app-components/dist/components/base/DateSelection/models';
import { GlobalDisclaimerLevel } from '@kurtosys/ksys-app-template/dist/models/disclaimers';
import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	token: '064d6d3f-8366-4388-ae35-fe6f200fa2d8',
	culture: {
		base: 'en-GB',
		default: 'en-GB',
	},
	core: {
		serviceUrl: 'https://api-rel.fundpress.io',
		skeletonLoaders: {
			variables: [
				{
					key: 'fillColor',
					value: '#dddddd',
				},
			],
			loaders: [
				{
					id: 'ksys-app-start',
					breakpoints: [
						{
							minWidthInPixels: 0,
							style: {
								height: '86px',
							},
							children: [
								{
									fill: '{fillColor}',
									x: '0px',
									y: '11.90625px',
									height: '28px',
									width: '100%',
								},
								{
									fill: '{fillColor}',
									x: '0px',
									y: '59.8125px',
									height: '18px',
									width: '100%',
								},
							],
						},
					],
				},
			],
		},
		inputs: {
			queries: [{
				queryId: 'startDate',
				queryOptionsType: 'timeseries',
				entityType: 'CLSS',
				code: 'growth_of_10k',
				key: 'date',
				placeholder: '-',
				index: 0,
				format: {
					type: 'date',
					options: {
						year: '2-digit',
						month: '2-digit',
						day: '2-digit',
					},
				},
			}, {
				queryId: 'endDate',
				queryOptionsType: 'timeseries',
				entityType: 'CLSS',
				code: 'returns',
				key: 'date',
				index: 1,
				placeholder: '-',
				format: {
					type: 'date',
					options: {
						year: '2-digit',
						month: '2-digit',
						day: '2-digit',
					},
				},
			}],
		},
	},
	data: {
		context: {
			entityByType: {
				FUND: {
					inputKey: 'isin',
					clientCodeProperty: 'isin',
					include: {
						statistics: {},
						timeseries: {},
					},
					searchEntityRequest: {
						type: 'CLSS',
					},
				},
				CLSS: {
					inputKey: 'isin',
					clientCodeProperty: 'isin',
					include: {
						statistics: {},
						timeseries: {},
					},
					searchEntityRequest: {
						applyFormats: true,
					},
				},
			},
			globalDisclaimers: [
				{
					global: true,
				},
			],
			// performanceCheck: {
			// 	start: {
			// 		queryOptionsType: 'property',
			// 		entityType: 'FUND',
			// 		code: 'fund_launch_date',
			// 	},
			// 	end: {
			// 		queryOptionsType: 'property',
			// 		entityType: 'FUND',
			// 		code: 'effective_date',
			// 	},
			// 	measure: {
			// 		operator: '>=',
			// 		value: 1,
			// 		period: 'YEARS',
			// 	},
			// },
		},
	},
	libraryComponents: {
		global: {
			formats: {
				percent: {
					type: 'percent',
					options: {
						maximumFractionDigits: 2,
						minimumFractionDigits: 2,
					},
					transforms: [
						{
							operator: 'divide',
							value: 100,
						},
					],
				},
			},
		},
	},
	components: {
		app: {
			globalInputIdentifiers: [
				'my-custom-input',
			],
			applicationId: 'test-application',
			listenFor: [
				{
					appId: 'ksys-global-inputs',
					eventTypes: [{
						name: 'ksys-global-inputs-change',
						requiredForInitialLoad: false,
					}],
				},
				{
					appId: 'ksys-pagination',
					eventTypes: [{
						name: 'ksys-on-pagination-change',
						requiredForInitialLoad: true,
						runOnce: false,
						cache: {
							enabled: true,
						},
					}],
				},
			],
			cardProps: {
				props: {
					title: 'The Title',
					subtitle: 'A Subtitle',
					disclaimers: {
						title: [
							{
								disclaimers: [
									{
										disclaimerType: 'Performance Disclaimer',
										textQuery: {
											queryOptionsType: 'none',
											options: {
												none: {
													value: 'This is some disclaimer test for the card title 1',
												},
											},
										},
										level: GlobalDisclaimerLevel.app,
									},
									{
										disclaimerType: 'Fees',
										textQuery: {
											queryOptionsType: 'none',
											options: {
												none: {
													value: 'This is some disclaimer test for the card title 2',
												},
											},
										},
										level: GlobalDisclaimerLevel.app,
									},
								],
							},
						],
						subTitle: [
							{
								disclaimers: [
									{

										disclaimerType: 'reg115',
										textQuery: {
											queryOptionsType: 'none',
											options: {
												none: {
													value: 'This is some disclaimer test for the card subTitle',
												},
											},
										},
										level: GlobalDisclaimerLevel.app,
									},
								],
							},
						],
					},

				},
			},
		},
		dateSelection: {
			mode: DateSelectionMode.calendar,
			calendarEndDateProps: {
				label: 'End Date',
				formatOptions: {
					dateFormatString: 'DD.MM.YYYY',
				},
			},
			calendarStartDateProps: {
				label: 'Start Date',
			},
			formatOverride: {
				type: 'date',
				options: {
					day: '2-digit',
					month: 'long',
					year: 'numeric',
				},
			},
		},
		asOfDate: {
			title: 'Returns',
			text: 'as of {date}',
			date: {
				queryOptionsType: 'timeseries',
				entityType: 'CLSS',
				code: 'returns',
				key: 'date',
				index: -1,
				placeholder: '-',
				format: {
					type: 'date',
					options: {
						year: '2-digit',
						month: '2-digit',
						day: '2-digit',
					},
				},
			},
		},
		chartPeriodSelection: {
			defaultPeriod: '1M',
			startDateFallBackDirection: 'backwards',
			defaultTickCount: 5,
			periods: [
				{
					key: 'YTD',
					value: 'YTD',
				},
				{
					value: '1W',
					customKey: {
						interval: 1,
						period: 'W',
					},
				},
				{
					value: '2W',
					customKey: {
						interval: 2,
						period: 'W',
					},
				},
				{
					value: '3W',
					customKey: {
						interval: 3,
						period: 'W',
					},
				},
				{
					value: '4W',
					customKey: {
						interval: 4,
						period: 'W',
					},
				},
				{
					key: '1M',
					value: '1M',
				},
				{
					value: '5W',
					customKey: {
						interval: 5,
						period: 'W',
					},
				},
				{
					value: '6W',
					customKey: {
						interval: 6,
						period: 'W',
					},
					tickCount: 6,
				},
				{
					value: '2M',
					customKey: {
						interval: 2,
						period: 'M',
					},
				},
				{
					key: '3M',
					value: '3M',
					tickCount: 3,
				},
				{
					value: '26W',
					customKey: {
						interval: 26,
						period: 'W',
					},
				},
				{
					key: '6M',
					value: '6M',
					tickCount: 6,
				},
				{
					value: '52W',
					customKey: {
						interval: 52,
						period: 'W',
					},
				},
				{
					value: '12M',
					customKey: {
						interval: 12,
						period: 'M',
					},
					tickCount: 12,
				},
				{
					key: '1Y',
					value: '1Y',
					tickCount: 12,
				},
				{
					key: '2Y',
					value: '2Y',
					tickCount: 12,
				},
				{
					key: '3Y',
					value: '3Y',
					tickCount: 6,
				},
				{
					key: '5Y',
					value: '5Y',
					tickCount: 5,
				},
				{
					key: '10Y',
					value: '10Y',
					tickCount: 10,
				},
				{
					key: 'ALL',
					value: 'Since Inception',
				},
			],
		},
		lineChart: {
			summaryQuery: {
				value: 'This chart has this summary',
				queryOptionsType: 'none',
			},
			chartProps: {
				composedChartProps: {
					height: 300,
					margin: {
						top: 20,
						right: 40,
						bottom: 20,
						left: 20,
					},
				},
				dateOptions: {
					xAxisDateAsNumber: true,
				},
				additionalElements: [
					{
						props: {
							x: 150,
							y: 150,
							dy: -25,
							style: { fontSize: 20, fill: '#000' },
							width: 200,
							// deprecated, should get excluded by component
							scaleToFit: true,
							textAnchor: 'middle',
							// deprecated, should get excluded by component
							verticalAnchor: 'middle',
							label: '11/1/04',
							capHeight: '1',
							// deprecated, should get excluded by component
							lineHeight: '1',
						},
						type: 'Text',
					},
					{
						props: {
							x: 150,
							y: 150,
							style: { fontSize: 20, fontWeight: 'bold', fill: '#000' },
							width: 200,
							// deprecated, should get excluded by component
							scaleToFit: true,
							textAnchor: 'middle',
							// deprecated, should get excluded by component
							verticalAnchor: 'middle',
							label: '$10,000',
							capHeight: '1',
							// deprecated, should get excluded by component
							lineHeight: '1',
						},
						type: 'Text',
					},
				],
				elementOverrides: {
					xAxis: {
						dataKey: 'date',
						domain: ['dataMin', 'dataMax'],
						tickFormatter: {
							type: 'date',
							options: {
								dateFormatString: 'DD MMMM \'YY',
								// month: 'long',
								// year: '2-digit',
							},
						},
						interval: 'preserveStartEnd',
					},
					yAxis: {
						axisLine: false,
						tickLine: false,
						tickPivotPoint: 100,
						domain: ['dataMin', 'dataMax'],
					},
					tooltip: {
						hide: false,
						cursor: {
							stroke: '#C7C7C7',
							strokeWidth: '1',
						},
						labelFormatter: {
							type: 'date',
							options: {
								year: '2-digit',
								month: 'short',
								day: '2-digit',
							},
						},
						formatter: {
							type: 'currency',
							currency: 'GBP',
							options: {
								style: 'currency',
								minimumFractionDigits: 1,
								maximumFractionDigits: 2,
							},
						},
					},
					cartesianGrid: {
						vertical: false,
					},
					legend: {
						iconType: 'square',
						showLegendTooltips: true,
					},
				},
				seriesProps: [
					// {
					// 	dataKey: 'benchmarkValue',
					// 	name: 'Benchmark',
					// 	stroke: '#BEBDBE',
					// 	strokeWidth: 2,
					// 	dot: false,
					// 	activeDot: false,
					// },
					{
						dataKey: 'value',
						name: 'Kurtosys Alpha Fund',
						stroke: '#C21B17',
						strokeWidth: 3,
						dot: false,
						toolTip: {
							content: 'This is the Kurtosys Alpha Fund tooltip',
							position: 'top',
						},
						disclaimers: [
							{
								disclaimers: [
									{
										disclaimerType: 'Test',
										textQuery: {
											queryOptionsType: 'none',
											value: 'This is a test disclaimer for Kurtosys Bond A EUR Acc',
										},
										level: GlobalDisclaimerLevel.app,
									},
								],
							},
						],
					},
				],
				breakpoints: [
					{
						size: 'medium',
						modifier: 'up',
						props: {},
					},
					{
						size: 'small',
						modifier: 'down',
						props: {
							elementOverrides: {
								xAxis: {
									dataKey: 'date',
									domain: ['dataMin', 'dataMax'],
									tickFormatter: {
										type: 'date',
										options: {
											dateFormatString: 'MMM \'YY',
										},
									},
									interval: 'preserveStartEnd',
								},
							},
							dateOptions: {
								xAxisDateAsNumber: true,
								xAxisTickOptions: {
									tickCount: 2,
									periodOptions: [
										{
											periodKey: '3M',
											tickCount: 2,
										},
										{
											periodKey: '6M',
											tickCount: 2,
										},
										{
											periodKey: '1Y',
											tickCount: 2,
										},
										{
											periodKey: '2Y',
											tickCount: 2,
										},
										{
											periodKey: '3Y',
											tickCount: 2,
										},
										{
											periodKey: '5Y',
											tickCount: 2,
										},
										{
											periodKey: '10Y',
											tickCount: 2,
										},
									],
								},
							},
						},
					},
				],
				rebaseOptions: {
					enabled: true,
					series: [
						{
							key: 'value',
							type: 'value',
						},
					],
					postTransforms: [
						{
							transformOptionsType: 'number',
							numberOptions: {
								operator: 'subtract',
								value: 100,
							},
						},
					],
				},
			},
			seriesPropsOverrides: [
				{
					dataKey: 'value',
					name: {
						queryOptionsType: 'property',
						entityType: 'CLSS',
						code: 'fund_name',
					},
					tooltip: {
						content: {
							queryOptionsType: 'none',
							value: 'This is the tooltip override',
						},
					},
				},
			],
			data: {
				queryOptionsType: 'timeseries',
				entityType: 'CLSS',
				code: 'growth_of_10k',
				// checkPerformanceAllowed: true,
				placeholder: '-',
				sort: {
					key: 'date',
					type: 'date',
					direction: 'ASC',
				},
			},
			disclaimers: [
				{
					queryOptionsType: 'disclaimers',
					key: 'Past Perf',
				},
				{
					queryOptionsType: 'disclaimers',
					key: 'performance_disclaimer',
				},
			],
		},

	},
	accessibilityConfig: {
		charting: {
			summary: {
				query: {
					value: 'This chart starts from this date {sub:startDate} and ends at this date {sub:endDate}',
					queryOptionsType: 'none',
					subQueries: [
						{
							queryId: 'startDate',
							queryOptionsType: 'input',
							options: {
								input: {
									key: 'startDate',
								},
							},
						},
						{
							queryId: 'endDate',
							queryOptionsType: 'input',
							options: {
								input: {
									key: 'endDate',
								},
							},
						},
					],
				},
			},
		},
	},
};
